import tw from './tw.js'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh-tw', // set locale
  messages: {
    "zh-tw": tw
  },
})

export default i18n